<header>
    <div class="text" mat-dialog-title>File Upload</div>
    <button mat-icon-button class="header" (tapped)="close()">
        <app-icon [icon]="{ type: 'icon', class: 'material-icons', content: 'close' }"></app-icon>
    </button>
</header>
<mat-dialog-content>
    <main>
        <div
            class="drop"
            [class.dropping]="isDropping"
            (dragover)="onDragOver($event)"
            (dragleave)="isDropping = false"
            (drop)="onDrop($event)"
        >
            <div class="icon">
                <i class="material-icons">cloud_upload</i>
            </div>
            <div class="text">Drag files to upload</div>
            <div class="sub-text">Files types: JPEG, PNG, TIFF, BMP, PDF</div>
            <div class="sub-text">Max file size: 20MB</div>
        </div>
        <div class="button">
            <button mat-button>
                Choose file to upload
                <input type="file" (change)="onFileChange($event)" />
            </button>
        </div>
        <div *ngIf="files_error.length > 0" class="error_msg">
            <span>File size greater than size limit for:</span>
            <li *ngFor="let file of files_error">{{ file.name }}</li>
        </div>
        <div class="files">
            <div class="file" *ngFor="let file of files">
                <span>{{ file.name }}</span>
                <i class="material-icons" (tapped)="remove(file.name)">close</i>
            </div>
        </div>
    </main>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button class="error" name="cancel" (tapped)="close()">Cancel</button>
    <button mat-button class="success" name="finish" (tapped)="finish()">Finish</button>
</mat-dialog-actions>
